<script>
// import Plyr from 'plyr'

export default {
  name: 'VideoWrapper',
  // data () {
  //   return {
  //     started: false
  //   }
  // },
  // mounted () {
  //   this.player = new Plyr(this.$el.querySelector('.plyr-player'));
  // },
  // methods: {
  //   play () {
  //     if (this.player) {
  //       this.player.play();
  //       this.started = true;
  //     }
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// assets/js/components/content/VideoWrapper.vue